var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-image center error"},[_c('font-awesome-icon',{attrs:{"icon":"image","size":_vm.iconSize}}),_c('small',[_vm._v("imagen no disponible")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }